import React from 'react';
import './calendar.css'; // Import custom CSS for styling
import { Table, Card } from 'react-bootstrap'; // Import Table and Card components from react-bootstrap
import room1 from '../../images/sb-images/r1.jpeg';
import room2 from '../../images/sb-images/r2.jpeg';

const Calendar = () => {
  // Sample data for demonstration
  const timeSlots = ['10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM'];
  const rooms = [
    { id: 1, name: 'Room 1', description: 'Description for Room 1', image: room1 },
    { id: 2, name: 'Room 2', description: 'Description for Room 2', image: room2 },
    { id: 3, name: 'Room 3', description: 'Description for Room 3', image: room1 },
    { id: 4, name: 'Room 4', description: 'Description for Room 4', image: room1 },
    { id: 5, name: 'Room 5', description: 'Description for Room 5', image: room2 }
  ];

  return (
    <div className="container">
      <Table borderless className="calendar-table">
        <thead>
          <tr>
            <th></th>
            {rooms.map(room => (
              <th key={room.id}><img src={room.image} alt={room.name} style={{ width: '50px', height: '50px', borderRadius:"50px" }} />{" "}{room.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {timeSlots.map(time => (
            <tr key={time}>
              <td>{time}</td>
              {rooms.map(room => (
                <td key={`${time}-${room.id}`}>
                  {/* Render card for each room */}
                  <Card className="calendar-card" style={{ maxWidth: "12rem", height: "auto" }}>
                    <Card.Body>
                      <Card.Text>{room.description}</Card.Text>
                      {/* You can add more content here */}
                    </Card.Body>
                  </Card>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default Calendar;
